"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var View = function View(_ref) {
  var onChange = _ref.onChange,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["onChange"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center py-2 px-4 text-lg rounded-full bg-secondary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-2"
  }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
    className: "!text-md text-gray-light"
  })), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, props, {
    spellCheck: false,
    type: "text",
    defaultValue: "",
    onChange: onChange,
    className: "flex-grow bg-secondary text-sm text-gray-medium",
    placeholder: "Search"
  })));
};

View.displayName = 'SearchInput';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=SearchInput.js.map